import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "nn__search-form__container" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("First 100 results are shown, please be more specific")
const _hoisted_4 = { class: "nn__search-result__list-container section__padding" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_footer_component = _resolveComponent("footer-component")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.searchString.length > 3 ? _ctx.search() : null), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            class: "nn__search-form__input",
            placeholder: "Minimum 4 characters",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchString) = $event)),
            type: "search"
          }, null, 512), [
            [_vModelText, _ctx.searchString]
          ]),
          _createElementVNode("button", {
            class: "nn__search-form__submit",
            type: "submit",
            disabled: _ctx.searchString.length < 4
          }, " Search ", 8, _hoisted_2)
        ], 32)
      ]),
      _createVNode(_component_ion_list, {
        style: {"display":"none"},
        class: "nn__search-result"
      }, {
        default: _withCtx(() => [
          (_ctx.searchResult.length === 100)
            ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "warning" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (item) => {
            return (_openBlock(), _createBlock(_component_ion_item, {
              button: "",
              key: item.objectId,
              onClick: ($event: any) => (_ctx.selectTopLevel(item)),
              color: _ctx.selectedItem?.objectId == item?.objectId ? 'primary' : ''
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`${item.componentName}: ${item.location ? item.location : ""} ${
            item.transformerCircuit ? item.transformerCircuit : ""
          }: ${item.meterNumber ? item.meterNumber : ""}`), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick", "color"]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "nn__search-result__list-item",
            key: item.objectId,
            onClick: ($event: any) => (_ctx.selectTopLevel(item))
          }, [
            _createElementVNode("div", null, _toDisplayString(item.componentName), 1),
            _createElementVNode("div", null, _toDisplayString(item.location), 1),
            _createElementVNode("div", null, _toDisplayString(item.objectId), 1),
            _createElementVNode("div", null, _toDisplayString(item.transformerCircuit), 1)
          ], 8, _hoisted_5))
        }), 128))
      ]),
      _createVNode(_component_footer_component)
    ]),
    _: 1
  }))
}